module.exports = __webpack_public_path__ + "static/img/Y2D300.65b4d25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Y2D300.png
// module id = PilB
// module chunks = 2